import React, { Fragment, useRef } from "react";
import Header from "./components/header";
import Content from "./components/content";
import Footer from "./components/footer"
import ShowcaseLayout from "./components/showcaseLayout"
import BriefLayout from "./components/briefLayout"
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Button, CssBaseline, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import AlertDialog from "./components/dialog";
import CheckoutDialog from "../../components/checkoutDialog";
import VideoPlayer from "./components/videoPlayer";
import AnimatedTextList from "./components/animationText";
import ToastCustom from "../../components/toastCustom";
import FingerprintJS from '@fingerprintjs/fingerprintjs' // 获取浏览器指纹
import { trackAdsConversion } from '../../utils/utils'

const PRODUCTS = [
    {
        "product_name": "ExcelTrial",
        "product": "excel",
        "amount": "5.00", // USD
        "adsConversion": {
            "WantGtagId": "AW-17429367033/cMipCJW2j_8aEPmR_PZA",
            "BuyGtagId": "AW-17429367033/19EOCKHVjv8aEPmR_PZA"
        },
        "img_url": "/assets/showcaseProductsBackground/ExcelTrial.png",
        "title": "体验版 | 🔥3天玩转Excel!",
        "contents": ["✅ 零基础入门Excel", "✅ CoCo私人AI工具试用3天", "✅ 轻松搞懂Excel正确学习姿势"],
        "product_term": 3 * 24 * 60 * 60,
        "product_share_link": `
        我用夸克网盘给你分享了「试听」，点击链接或复制整段内容，打开「夸克APP」即可获取。
        /~ccd437fhQO~:/
        链接：https://pan.quark.cn/s/e2afdce1c35a
        提取码：MP5m`,
        "briefing": "零基础? 别怕! 3天带你玩转Excel, 轻松入门职场必备技能!为什么学Excel? 怎么学最爽?独特幽默和AI工具辅助方式, 让你笑着学会!限时体验, 速来!"
    },
    {
        "product_name": "ExcelPrimary",
        "product": "excel",
        "amount": "18.00", // USD
        "adsConversion": {
            "WantGtagId": "AW-17429367033/3BZZCJi2j_8aEPmR_PZA",
            "BuyGtagId": "AW-17429367033/YRJWCOrrjv8aEPmR_PZA"
        },
        "img_url": "/assets/showcaseProductsBackground/ExcelPrimary.png",
        "title": "基础版 | 💡Excel小白逆袭!",
        "contents": ["✅ 函数公式全掌握(基础操作+函数公式)", "✅ 3个月1v1专属AI工具辅导", "✅ 硬核姿势🚫不枯燥"],
        "product_term": 3 * 30 * 24 * 60 * 60,
        "product_share_link": `
        我用夸克网盘给你分享了「基础」等2项，点击链接或复制整段内容，打开「夸克APP」即可获取。
        /~d45b37fhr9~:/
        链接：https://pan.quark.cn/s/193bc3873e5d
        提取码：YizY`,
        "briefing": "函数公式不会用? 数据整理总出错? 3个月系统讲解+AI工具辅导咨询, 手把手教你Excel核心操作!直接秒变办公效率王, 升职加薪不是梦!"
    },
    {
        "product_name": "ExcelMiddle",
        "product": "excel",
        "amount": "38.00", // USD
        "adsConversion": {
            "WantGtagId": "AW-17429367033/puTfCJb4j_8aEPmR_PZA",
            "BuyGtagId": "AW-17429367033/GwJrCIr6jv8aEPmR_PZA"
        },
        "img_url": "/assets/showcaseProductsBackground/ExcelMiddle.png",
        "title": "进阶版 | 📊秒变数据分析大神!",
        "contents": ["✅ 专业图表轻松做", "✅ 6个月超长AI工具1v1陪跑", "✅ 数据分析实战在线解答"],
        "product_term": 6 * 30 * 24 * 60 * 60,
        "product_share_link": `
        我用夸克网盘给你分享了「进阶」等3项，点击链接或复制整段内容，打开「夸克APP」即可获取。
        /~75e937fhby~:/
        链接：https://pan.quark.cn/s/7b0620a2c2ca
        提取码：qFWq`,
        "briefing": "图表丑? 数据不会分析? 专属魔鬼训练方法, AI工具暖心☺️辅导, 教你玩透数据可视化、动态图表、透视表! 让老板眼前一亮, 同事直呼\"大神\"!"
    },
    {
        "product_name": "ExcelSenior",
        "product": "excel",
        "amount": "68.00", // USD
        "adsConversion": {
            "WantGtagId": "AW-17429367033/cMipCJW2j_8aEPmR_PZA",
            "BuyGtagId": "AW-17429367033/19EOCKHVjv8aEPmR_PZA"
        },
        "img_url": "/assets/showcaseProductsBackground/ExcelSenior.png",
        "title": "高阶版 | 🚀Excel年薪翻倍!",
        "contents": ["✅ 职场硬核技能包", "✅ AI工具1年期 1v1贴心辅导", "✅ 真实案例拆解"],
        "product_term": 12 * 30 * 24 * 60 * 60,
        "product_share_link": `
        我用夸克网盘给你分享了「高阶」等4项，点击链接或复制整段内容，打开「夸克APP」即可获取。
        /~1f1437fhQV~:/
        链接：https://pan.quark.cn/s/2a02d843ca26
        提取码：86Hd`,
        "briefing": "Excel玩到极致是什么体验? 深度实战+家案例拆解, 自动化报表、复杂建模、商业分析全搞定! 直接碾压身边同事, 成为公司最靓的仔!"
    },
];

function getQueryParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      product: params.get('product'),
    };
  }


export default function Home(props) {
    // const footerRef = useRef(null);
    const showcaseRef = useRef(null);
    const briefRef = useRef(null);
    const [isDialogOpen, setDialogOpen] = React.useState(false);
    const [isCheckoutDialogOpen, setCheckoutDialogOpen] = React.useState(false);
    const [isComingSoonDialogOpen, setComingSoonDialogOpen] = React.useState(false);
    const [content, setContent] = React.useState("")
    const [ticket, setTicket] = React.useState("")
    const [selectedProduct, setSelectProduct] = React.useState(PRODUCTS[0])
    const [isToastOpen, setToastOpen] = React.useState(false)

    const params = getQueryParams()
    console.log(params)
    const initProductIndex = Number(params.product);
    const onInit = React.useEffect(() => {
        console.log("Init...")
        const userAgent = navigator.userAgent;
        console.log(userAgent)
        console.log(initProductIndex)
        if (!isNaN(initProductIndex)) {
            if (initProductIndex>=0 && initProductIndex<PRODUCTS.length) {
                setSelectProduct(PRODUCTS[initProductIndex]);
                setCheckoutDialogOpen(true); 
            }
        }

        const loadFingerprint = async () => {
            const fp = await FingerprintJS.load();
            const result = await fp.get();
            // console.log("visitorId:", result.visitorId);
            // console.table(result.components);
            fetch('https://coco-excel.mindlink.work/api/oauth-token', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    finger_print: result.visitorId,
                    ua: userAgent,
                    components: result.components
                }),
                })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                })
          };

        
          loadFingerprint();
    }, [initProductIndex]); // 只在 URL 参数变化时触发

    const handleClickMenuItem = (whichNode) => {
        console.log(whichNode)
        const ref = whichNode === "咨询我" ? showcaseRef:briefRef;
        ref.current?.scrollIntoView({ behavior: "smooth" });
    };
    const handleDialogClose = async () => {
        setDialogOpen(false)
        console.log(ticket)
        // setTicket("")
        console.log("copy")
        try {
            await navigator.clipboard.writeText(ticket);
            // alert('已复制到剪贴板! 确认后进入1v1辅导');
            window.location.href = "https://meera.mindlink.tools";
        } catch (err) {
            alert('复制失败，请手动复制');
        }
    };
    const handleClickShowcaseItem = (index) => {
        if (index > 0) {
            // 做一个弹框提示
            setComingSoonDialogOpen(true);
            return;
        }
        setSelectProduct(PRODUCTS[index]);
        setCheckoutDialogOpen(true);
        // 跟踪转化
        trackAdsConversion(PRODUCTS[index].adsConversion.WantGtagId, 0.1, 'CNY');
    };
    const handlePaymentSuccess = (data) => {
        console.log(data)
        setCheckoutDialogOpen(false)
        // [TODO] 做一个正在获取结果的提示
        setToastOpen(true)
        // POST请求示例
        fetch('https://coco-excel.mindlink.work/api/order-storage', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                product: selectedProduct.product,
                order_res: data.details,
                product_term: selectedProduct.product_term,
                product_share_link: selectedProduct.product_share_link
            }),
            })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                // setCheckoutDialogOpen(false)
                setToastOpen(false)
                setDialogOpen(true)
                setTicket(data.ticket)
                const content = `
                    🎉您的兑换码(1v1线上咨询服务):
                    (${data.ticket})
                    (复制，并跳转至 https://meera.mindlink.tools 进行兑换)

                    🔗课程链接:
                    ${selectedProduct.product_share_link}
        
                    提示:
        
                    📩 以上信息邮件已发送至您的邮箱(${data.mail})，请查收（包括垃圾箱）
                    `;
                setContent(content);
            })
            .catch(err => console.error(err));
            // 跟踪转化
            trackAdsConversion(selectedProduct.adsConversion.BuyGtagId, 1, 'CNY');
    };
    return(
    <Fragment>
        <CssBaseline /> {/* 重置默认边距 */}
        <Box
            sx={{
                // backgroundImage: 'url(/assets/pexels-mart-production-7222979.jpg)',
                backgroundImage: {xs: 'url(/assets/header_bg_xs.png)', sm: 'url(/assets/header_bg_sm.png)'},
                backgroundSize: 'cover', // 或 'contain'
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                height: '100vh', // 必须设置高度
                width: '100%', // 可选宽度
                display: 'flex',
                flexDirection: 'column'
            }}>
            <Header onClickMenuItem={handleClickMenuItem} ></Header>
            <Content onClickRightButton={() => {
                setSelectProduct(PRODUCTS[0]);
                setCheckoutDialogOpen(true);
            }} onClickLeftButton={()=>{
                const ref = showcaseRef;
                ref.current?.scrollIntoView({ behavior: "smooth" });
            }} />
        </Box>
        {/* 下滑页部分 */}
        <Box sx={{ width: '100%' }}>
            <Stack spacing={0}>
                <Box ref={showcaseRef} sx={{ backgroundColor: "#EFDDD0", position: 'relative', display: 'flex',justifyContent: 'center',alignItems: 'center', width: '100%', height: {xs: "50%", sm: "100vh"} }}>
                    <ShowcaseLayout products={PRODUCTS} onClickItem={handleClickShowcaseItem} />
                </Box>
                {/* <BriefLayout /> */}
                <Box ref={briefRef} sx={{
                    minHeight: {xs: "90vh", sm: "100vh"},
                    width: '100%',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: {sm: 'row', xs: 'column-reverse'},
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: "#EFDDD0"
                }}>
                    <Box sx={{ width: {sm: '40%', xs: '100%'},
                               display: 'flex',
                               justifyContent: 'center',
                               alignContent: 'center',
                               flexWrap: 'wrap',
                               flexDirection: 'column',
                               gap: 10 }}>
                        <AnimatedTextList></AnimatedTextList>
                        <Button
                            variant="contained"
                            // onClick={() => handleDialogOpen(!isOpenDialog)}
                            onClick={()=>{
                                setSelectProduct(PRODUCTS[0]);
                                setCheckoutDialogOpen(true);
                            }}
                            sx={{
                            color: '#EFDDD0',
                            backgroundColor: '#EF7F95',
                            '&:hover': {
                            backgroundColor: alpha('#EF7F95', 0.8)
                            },
                            borderRadius: '0px',
                            height: '45px',
                            marginRight: 1,
                            fontWeight: 900,
                            fontSize: 17
                            }}>
                            一起探索
                        </Button>
                    </Box>
                    <Box sx={{ width: {sm: '60%', xs: '100%'}, display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                        <VideoPlayer/> 
                    </Box>
                </Box>
                <BriefLayout />
            </Stack>
        </Box>
        <CheckoutDialog open={isCheckoutDialogOpen} productInfo={selectedProduct} onPaymentSuccess={handlePaymentSuccess} onClose={()=>{setCheckoutDialogOpen(false)}} />
        <AlertDialog open={isDialogOpen} onClose={handleDialogClose} title="支付成功" content={content} mainButton="复制并跳转"></AlertDialog>
        <AlertDialog open={isComingSoonDialogOpen} onClose={()=>{setComingSoonDialogOpen(false)}} title="压箱底秘籍，正在整理中" content="数月打磨，只为呈现最实用的 Excel 干货。课程即将上线，敬请期待。" mainButton="好的"></AlertDialog>
        <ToastCustom open={isToastOpen} msg="正在获取支付结果" />
        <Footer></Footer>

    </Fragment>)
}
